import { z } from 'zod';

const itemBaseSchema = z.object({
  itemPath: z.string(),
  title: z.string(),
  url: z.string().nullish(),
  icon: z.string().nullish(),
  openInNewTab: z.boolean().nullish(),
  isViewable: z.boolean().nullish(),
});

export type MenuItem = z.infer<typeof itemBaseSchema> & {
  subItems: MenuItem[];
};

export const menuItemSchema: z.ZodType<MenuItem> = itemBaseSchema.extend({
  subItems: z.lazy(() => menuItemSchema.array()),
});
